import { render } from "./OapChannelAdvisor.vue?vue&type=template&id=2d490172"
import script from "./OapChannelAdvisor.vue?vue&type=script&lang=js"
export * from "./OapChannelAdvisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__